'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import Theme from '../util/Theme.jsx';

/**
 * A FormInput component for use in forms
 */
const FormInput = ({
	size,
	width = 'normal',
	value,
	name,
	onChange,
	placeHolder = 'Enter Search',
	styles,
	type = 'text',
	autoComplete,
	id,
	disabled = false,
	onBlur,
}) => {
	let getStyles = () => {
		return {
			padding: '.5em',
			height: '31px',
			verticalAlign: 'middle',
			borderRadius: '0.6em',
			border: '2px solid #ccc',
			outline: 'none',
			fontSize: Theme.getSize(size),
			color: 'grey',
			width: FormInput.widths[width]
		};
	};

	const css = getStyles();
	styles = { ...css, ...styles };
	//if(width === 'large') styles.push(css.large);


	return (
		<input
			type={type}
			className="Input"
			style={styles}
			id={id}
			name={name}
			onChange={onChange}
			onBlur={onBlur}
			placeholder={placeHolder}
			value={value}
			autoComplete={autoComplete}
			disabled={disabled}
		/>
	);
};

FormInput.propTypes = {
	/** The color theme of the input */
	//color: PropTypes.oneOf(Theme.colorList),
	color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'info', 'inactive']),

	/** Input font size */
	size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large']),

	/** The width of the search input */
	width: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large']),

	/**  Input value */
	value: PropTypes.string,

	/**  Input name */
	name: PropTypes.string,

	/**  Input placeholder text */
	placeHolder: PropTypes.string,

	/** Input type */
	type: PropTypes.string,

	/** Autocomplete hint */
	autoComplete: PropTypes.string,

	/** Input id */
	id: PropTypes.string,

	/** Disabled input */
	disabled: PropTypes.bool,

	/** Input blur handler */
	onBlur: PropTypes.func,
};

FormInput.widths = {
	xsmall: '50px',
	small: '200px',
	normal: '250px',
	large: '400px',
};

export default FormInput;